import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Cangjie3 input method editor (IME)", -1 /* CACHED */)),
    _cache[1] || (_cache[1] = _createElementVNode("h2", null, [
      _createTextVNode("(Try this: "),
      _createElementVNode("code", null, "oiar grmbc yhgr jnd ."),
      _createTextVNode(")")
    ], -1 /* CACHED */)),
    _createVNode($setup["TheTextarea"]),
    (!$setup.is_punctuation_code)
      ? (_openBlock(), _createBlock($setup["Hints"], { key: 0 }))
      : _createCommentVNode("v-if", true),
    ($setup.is_punctuation_code)
      ? (_openBlock(), _createBlock($setup["Matrix"], { key: 1 }))
      : _createCommentVNode("v-if", true),
    _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
    _createVNode($setup["TheConsole"])
  ], 64 /* STABLE_FRAGMENT */))
}